<template>
  <div class="connections">
    <h2>
      Connect JourneyBinder to your world in order to send and get data that
      will be used in your tools.
    </h2>

    <div
      class="tags d-flex justify-content-between align-items-center flex-wrap"
    >
      <div class="myTags">
        <div
          class="tag"
          v-for="(tag, i) in myTags"
          :key="i"
          @click="toogleFilter(tag)"
          :class="{ active: activeTags.indexOf(tag) >= 0 }"
        >
          {{ tag }}
        </div>
      </div>
      <div class="sortInput">
        <div class="sortTags">
          <div
            class="tag"
            v-for="(tag, i) in sortTags"
            :key="i"
            @click="toogleSort(tag)"
            :class="{ active: activeSortTags.indexOf(tag) >= 0 }"
          >
            {{ tag }}
          </div>
        </div>
        <b-input-group class="input">
          <b-input-group-prepend>
            <span class="input-group-text"
              ><svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M7.33334 2.66634C4.75601 2.66634 2.66668 4.75568 2.66668 7.33301C2.66668 9.91034 4.75601 11.9997 7.33334 11.9997C9.91067 11.9997 12 9.91034 12 7.33301C12 4.75568 9.91067 2.66634 7.33334 2.66634ZM1.33334 7.33301C1.33334 4.0193 4.01963 1.33301 7.33334 1.33301C10.6471 1.33301 13.3333 4.0193 13.3333 7.33301C13.3333 10.6467 10.6471 13.333 7.33334 13.333C4.01963 13.333 1.33334 10.6467 1.33334 7.33301Z"
                  fill="#B3C2CB"
                />
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M10.6286 10.6289C10.8889 10.3685 11.311 10.3685 11.5714 10.6289L14.4714 13.5289C14.7317 13.7892 14.7317 14.2113 14.4714 14.4717C14.211 14.732 13.7889 14.732 13.5286 14.4717L10.6286 11.5717C10.3682 11.3113 10.3682 10.8892 10.6286 10.6289Z"
                  fill="#B3C2CB"
                />
              </svg>
            </span>
          </b-input-group-prepend>
          <b-form-input class="search-input" placeholder="Search Connections">
          </b-form-input>
        </b-input-group>
      </div>
    </div>
    <div class="tools">
      <div class="row__tools">
        <div
          class=" tool"
          :class="{ active: activeTools.indexOf(tool.id) >= 0 }"
          v-for="(tool, i) in tools"
          :key="i"
          @click="openModal(tool)"
        >
          <div class="top">
            <div class="left">
              <img :src="tool.imgURL" alt="" />
              <h4>{{ tool.name }}</h4>
              <span :class="[tool.name, 'indicator']">
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    opacity="0.3"
                    cx="10"
                    cy="10"
                    r="10"
                    :fill="tool.color"
                  />
                  <circle cx="10" cy="10" r="7" :fill="tool.color" />
                </svg>
              </span>
            </div>
            <div class="right">
              <!-- @click="toogleTools(tool.id)" -->
              <span>
                <svg
                  v-if="activeTools.indexOf(tool.id) >= 0"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle cx="12" cy="12" r="12" fill="#E8EAF9" />
                  <path
                    d="M4 13.875L8.09091 18L19 7"
                    stroke="var(--theme-color)"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>

                <!-- {{!(activeCrew.indexOf(cr)>=0)}} -->
                <svg
                  v-else
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <circle
                    cx="12"
                    cy="12"
                    r="12"
                    fill="var(--theme-color)"
                    fill-opacity="0.1"
                  />
                  <path
                    d="M12.0002 5.14282V18.8571"
                    stroke="var(--theme-color)"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                  <path
                    d="M5.14282 12.0002L18.8571 12.0002"
                    stroke="var(--theme-color)"
                    stroke-width="2"
                    stroke-linecap="round"
                  />
                </svg>
              </span>
            </div>
          </div>

          <p>{{ tool.description || "No Description" }}</p>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="pagination" @click="pagination($event)">
          <div class="page" @click="prev()">
            <span>
              <svg
                width="11"
                height="11"
                viewBox="0 0 11 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5.72868 1.50239C5.96447 1.2666 5.96447 0.884309 5.72868 0.648521C5.49289 0.412733 5.1106 0.412733 4.87481 0.648521L0.648399 4.87494C0.412611 5.11072 0.412611 5.49301 0.648399 5.7288L4.87481 9.95522C5.1106 10.191 5.49289 10.191 5.72868 9.95522C5.96447 9.71943 5.96447 9.33714 5.72868 9.10135L2.53297 5.90564H9.52816C9.86162 5.90564 10.1319 5.63532 10.1319 5.30187C10.1319 4.96841 9.86162 4.69809 9.52816 4.69809H2.53297L5.72868 1.50239Z"
                  :fill="[activePage == 1 ? '#ddd' : 'var(--theme-color)']"
                />
              </svg>
            </span>
          </div>

          <div
            class="page"
            @click="makeActive(1)"
            :class="{ active: activePage == 1 }"
          >
            1
          </div>
          <div
            class="page"
            @click="makeActive(2)"
            :class="{ active: activePage == 2 }"
          >
            2
          </div>
          <div
            class="page"
            @click="makeActive(3)"
            :class="{ active: activePage == 3 }"
          >
            3
          </div>
          <div class="page">...</div>
          <div
            class="page"
            @click="makeActive(9)"
            :class="{ active: activePage == 9 }"
          >
            9
          </div>
          <div class="page" @click="next()">
            <span>
              <svg
                width="11"
                height="11"
                viewBox="0 0 11 11"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fill-rule="evenodd"
                  clip-rule="evenodd"
                  d="M5.72868 0.648521C5.49289 0.412733 5.1106 0.412733 4.87481 0.648521C4.63903 0.884309 4.63903 1.2666 4.87481 1.50239L8.07052 4.69809H1.07533C0.741876 4.69809 0.471558 4.96841 0.471558 5.30187C0.471558 5.63532 0.741876 5.90564 1.07533 5.90564H8.07052L4.87481 9.10135C4.63903 9.33714 4.63903 9.71943 4.87481 9.95522C5.1106 10.191 5.49289 10.191 5.72868 9.95522L9.95509 5.7288C10.1909 5.49301 10.1909 5.11072 9.95509 4.87494L5.72868 0.648521Z"
                  :fill="[activePage == 9 ? '#ddd' : 'var(--theme-color)']"
                />
              </svg>
            </span>
          </div>
        </div>
      </div>
    </div>
    <b-modal
      :id="tagModal"
      hide-footer
      hide-header
      centered
      size="sm"
      :ref="tagModal"
      body-class="p-0"
      class="my_modal"
    >
      <!-- Header -->
      <div class="form-header">
        <span @click="$bvModal.hide(tagModal)" class="close">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="12" cy="12" r="12" fill="#E4E6EB" />
            <g clip-path="url(#clip0)">
              <path
                d="M12.5894 12.0013L17.2114 7.37929C17.3741 7.21656 17.3741 6.95272 17.2114 6.79002C17.0486 6.62731 16.7848 6.62729 16.6221 6.79002L12.0001 11.412L7.37806 6.79002C7.21534 6.62729 6.9515 6.62729 6.78879 6.79002C6.62609 6.95274 6.62607 7.21658 6.78879 7.37929L11.4108 12.0013L6.78879 16.6233C6.62607 16.7861 6.62607 17.0499 6.78879 17.2126C6.87015 17.294 6.97679 17.3346 7.08344 17.3346C7.19009 17.3346 7.29671 17.294 7.37809 17.2126L12.0001 12.5906L16.6221 17.2126C16.7034 17.294 16.8101 17.3346 16.9167 17.3346C17.0234 17.3346 17.13 17.294 17.2114 17.2126C17.3741 17.0499 17.3741 16.786 17.2114 16.6233L12.5894 12.0013Z"
                fill="#606770"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect
                  width="10.6667"
                  height="10.6667"
                  fill="white"
                  transform="translate(6.66675 6.66699)"
                />
              </clipPath>
            </defs>
          </svg>
        </span>
        <h2 class="text-center">{{ connectData.name }}</h2>
        <img :src="connectData.imgURL" :alt="`${connectData.name} image`" />
        <p>
          {{ connectData.text }}
        </p>
      </div>
      <!-- Header -->
      <b-form class="form">
        <b-form-group>
          <b-form-input
            type="text"
            required
            placeholder="Username"
            class="custom_input"
            v-model="Username"
          ></b-form-input>
        </b-form-group>
        <b-form-group>
          <b-form-input
            type="password"
            required
            placeholder="Password"
            class="custom_input"
            v-model="Password"
          ></b-form-input>
        </b-form-group>
        <div class="foot">
          <b-button variant="primary btn-round-fill" @click="connect()"
            >Connect</b-button
          >
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
//import firebase from "../../../../../firebase.json";
import firebase from "firebase";
export default {
  data() {
    return {
      myTags: ["Accounts", "IOT", "Finance"],
      tagModal: "connection-modal",
      sortTags: ["A-Z", "Z-A", "Newest"],
      isActive: false,
      Username: "",
      Password: "",
      activePage: 1,

      activeTags: [],
      activeSortTags: [],
      connectData: {},
      activeTools: [],
      tools: []
    };
  },
  mounted() {
    this.$store.dispatch("listings/getListConnections").then(res => {
      this.tools = res;
    });
  },
  methods: {
    connectGoogleAPI() {
      let tool = "drive";
      let scope = "https://www.googleapis.com/auth/drive";
      const getAuthUrl = firebase
        .functions()
        .httpsCallable("googleAPI-getAuthUrl");
      // https://us-central1-myjourneybinderdev.cloudfunctions.net/googleAPI-getAuthUrl
      //https://us-central1-myjourneybinderdev.cloudfunctions.net/googleAPI-oauth2callback
      const self = this;
      self.isLoading = true;
      getAuthUrl({
        uid: this.$store.getters["user/user"].uid,
        scope: scope,
        tool: tool,
        redirect: `https://my.journeybinder.com/me#connections`
      })
        .then(res => {
          console.log("response url", res);
          const url = res.data.authUrl;
          let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,width=500,height=600,left=100,top=100`;
          window.open(url, "authgcwindow", params);
          self.isLoading = false;
        })
        .catch(error => {
          console.log("error", error);
          self.isLoading = false;
        });
    },
    toogleFilter(tag) {
      let index = this.activeTags.indexOf(tag);
      if (index >= 0) {
        this.activeTags.splice(index, 1);
      } else {
        this.activeTags.push(tag);
      }
    },
    makeActive(page) {
      this.activePage = page;
    },
    next() {
      if (this.activePage == 9) {
        this.activePage = 1;
      } else {
        this.activePage++;
      }
    },
    prev() {
      if (this.activePage == 1) {
        this.activePage = 9;
      } else {
        this.activePage--;
      }
    },

    pagination(e) {
      console.log(document.querySelectorAll(".page"));
      console.log(e.target.classList[0]);
    },
    toogleSort(tag) {
      this.activeSortTags = [];
      this.activeSortTags.push(tag);
    },
    openModal(toolData) {
      let index = this.activeTools.indexOf(toolData.id);
      if (index >= 0) {
        this.connect();
        return;
      } else {
        this.$bvModal.show(this.tagModal);
        this.connectData = toolData;
      }
    },
    connect() {
      this.connectGoogleAPI();

      /*let index = this.activeTools.indexOf(this.connectData.id);
      if (index >= 0) {
        this.activeTools.splice(index, 1);
        return;
      } else {
        this.activeTools.push(this.connectData.id);
      }
      this.$bvModal.hide(this.tagModal);*/
    }
  }
};
</script>

<style lang="scss" scoped>
.connections {
  margin-top: 24px;
  font-family: "Nunito", sans-serif;
  h2 {
    margin-bottom: 16px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    display: flex;
    align-items: center;

    color: #000000;
  }

  .tags {
    margin-top: 20px;
    @media (max-width: 550px) {
      flex-direction: column;
    }
    .myTags {
      display: flex;
      flex-wrap: wrap;
    }
    .sortInput {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      @media (max-width: 550px) {
        flex-direction: column;
      }
      @media (max-width: 1050px) {
        margin-top: 20px;
      }
      .sortTags {
        display: flex;
        flex-wrap: wrap;
      }
    }

    .tag {
      cursor: pointer;
      padding: 8px 16px;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 19px;
      background-color: #fff;
      color: #5b606c;
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
      border-radius: 32px;
      margin-right: 16px;
      @media (max-width: 380px) {
        margin-top: 20px;
      }
      &.active {
        background: rgba(85, 126, 251, 0.1);
        color: var(--theme-color);
        box-shadow: none;
      }
    }
  }
  .input {
    border: none !important;
    @media (max-width: 550px) {
      margin-top: 20px;
    }

    height: 22px;
    width: 200px;
    // width: 100%;

    &:focus,
    &:hover {
      outline: none !important;
      border: none;
      box-shadow: none;
    }

    .search-input {
      border-left: none;
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 22px;
      display: flex;
      align-items: center;
      color: #474d52;
      border: none !important;
      &:focus,
      &:hover {
        outline: none !important;
        border: none;
        box-shadow: none;
      }
      &::placeholder {
        font-size: 14px;
        line-height: 22px;
        display: flex;
        align-items: center;
        color: #b3c2cb;
      }
    }

    .input-group-text {
      border-right: none;
      background-color: #ffffff;
      border: none !important;
      cursor: pointer;
    }
  }

  .tools {
    margin-top: 32px;
    .row__tools {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
      grid-column-gap: 10px;
    }
    .tool {
      max-width: 285px;
      width: 100%;
      cursor: pointer;
      @media (max-width: 1024px) {
        margin-left: auto;
        margin-right: auto;
        flex: 0 0 50%;
      }
      @media (max-width: 630px) {
        margin-left: auto;
        margin-right: auto;
        flex: 0 0 100%;
      }
      background: #ffffff;
      box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
      border-radius: 8px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin-bottom: 24px;
      &.active {
        background: rgba(85, 126, 251, 0.1);
        box-shadow: none;
      }
      .top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-top: 18px;
        padding-left: 18px;
        .left {
          display: flex;
          align-items: center;
          position: relative;
          .indicator {
            position: absolute;
            right: 68%;
            bottom: -13%;
          }
          .indicator.Measure {
            position: absolute;
            right: 59%;
            bottom: -16%;
          }
          .indicator.Alexa {
            position: absolute;
            right: 55%;
            bottom: -13%;
          }
          .indicator.Lift {
            position: absolute;
            right: 37%;
            bottom: -13%;
          }
          img {
            width: 32px;
            height: 32px;
            object-fit: cover;
          }

          h4 {
            font-style: normal;
            font-weight: normal;
            font-size: 16px;
            color: #474d52;
            margin-left: 8px;
            margin-top: 11px;
          }
        }
        .right {
          padding-right: 18px;
          display: flex;
          align-items: center;
          span {
            &.active {
              display: none;
            }
          }
        }
      }
      p {
        font-style: normal;
        font-weight: normal;
        font-size: 12px;
        color: #474d52;
        padding-left: 18px;
        margin-top: 8px;
        padding-right: 18px;
      }
    }
  }
}
.pagination {
  display: flex;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
  -khtml-user-select: none; /* Konqueror HTML */
  -moz-user-select: none; /* Old versions of Firefox */
  -ms-user-select: none; /* Internet Explorer/Edge */
  user-select: none; /* Non-prefixed version, currently
                                  supported by Chrome, Edge, Opera and Firefox */
  .page {
    max-width: 32px;
    width: 100%;
    height: 32px;
    // height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 5px;
    // filter: drop-shadow(0px 4px 12px rgba(0, 0, 0, 0.08));
    // background-color: var(--theme-color);
    border-radius: 50%;
    color: #b3c2cb;
    cursor: pointer;
    &.active {
      color: var(--theme-color);
    }
    &:first-child,
    &:last-child {
      filter: drop-shadow(0px 4px 12px rgba(0, 0, 0, 0.08));
      background-color: #fff;
    }
  }
}
.form-header {
  h2 {
    font-style: normal;
    font-weight: 600;
    font-size: 24px;
    color: #474d52;
    padding-top: 44px;
    padding-left: 45px;
  }
  .close {
    margin-right: 24px;
    padding-top: 24px;
    cursor: pointer;
  }
  img {
    margin-top: 24px;
    text-align: center;
    margin-bottom: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: auto;
    margin-right: auto;
    // width: 124px;
    height: 100px;
    object-fit: cover;
  }
  p {
    margin-left: auto;
    margin-right: auto;
    max-width: 380px;
    width: 100%;
    font-weight: normal;
    font-size: 16px;
    line-height: 22px;
    display: flex;
    align-items: center;

    /* Body */

    color: #474d52;
  }
}
.form {
  max-width: 390px;
  width: 100%;
  margin: 32px auto;
  .custom_label {
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 16px;
    display: flex;
    align-items: center;
    width: 100%;
    color: var(--theme-color);
  }
  .custom_input {
    background: #ffffff;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.08);
    border-radius: 100px;
    border: none;
    outline: none;
    padding: 13px 21px;
    max-width: 380px;
    height: 48px;
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    color: #474d52;
    &:focus {
      border: none;
      outline: none;
    }
    &::placeholder {
      font-weight: 600;
      font-size: 14px;
      color: #a1b1ba;
      margin-bottom: 8px;
    }
  }

  .btn-round-fill {
    max-width: 381px;

    width: 100%;
    height: 48px;
    background: var(--theme-color);
    box-shadow: 0px 0px 15px rgba(0, 0, 0, 0.07);
    border-radius: 100px !important;
    // margin-bottom: 80px;
  }
  .foot {
    text-align: center;
    margin-top: 24px;
    margin-bottom: 29px;
  }
}
</style>
